<template>
  <ul class="qest_law_frim">
    <li class="wi "  v-for="(item,index) in 5" :key="index" :class="{act:index==lawfrim_active}" @mouseover="lawfrim_mouse(index)">
      <div v-if="lawfrim_active == index">
        <div class="tit ellipsis">北京盈科（合肥）律师事务所</div>
        <p class="dec ellipsis">
          地址：合肥市 蜀山区习友路与潜山路交口华润大厦A座26-27层
        </p>
      </div>
      <div class="ellipsis" v-else>律师事务所列表</div>
    </li>
  </ul>
</template>

<script>
export default {
  data: () => ({
    lawfrim_active: 0,
  }),
  methods: {
    lawfrim_mouse(index) {
      this.lawfrim_active = index;
    },
  },
};
</script>

<style lang="scss" scope>
.qest_law_frim {
  width: 100%;
  .wi {
    font-size: 16px;
    color: #666666;
    padding: 16px 0;
    margin-left: 30px;
    position: relative;
    list-style: disc;
  }
  .act {
    padding: 20px 26px;
    list-style: none;
    margin-left: 0;
    height: 92px;
    box-shadow: 0 0 5px 0 rgb(0 0 0 / 10%);
    background: url(../../../assets/findlawyers/lawfirm_sample.png) no-repeat;
    background-size: 100% 100%;
    .tit {
      width: 475px;
      font-size: 18px;
      color: #0465ea;
    }
    .dec {
      margin-top: 10px;
      font-size: 14px;
      color: #999999;
    }
  }
}
</style>